// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","main":"Footer_main__6S4ub","left":"Footer_left__uf-wb","links":"Footer_links__2VAlO","awards":"Footer_awards__cNP0a","bottom":"Footer_bottom__J7kjW"};